
<!-- Skills -->
<app-scotty-card [title]="'Skills' | translate" hideDivisor="true" [actions]="getSkillActions()">
  <ng-container *ngIf="!isLoading; else loading">
    <app-table #skillsTable [columns]="getSkillsTableColumns()" [rows]="getSkillsTableData()" [paginator]="skillsPaginator"></app-table>
  </ng-container>
</app-scotty-card>


<!-- Skill levels -->
<app-scotty-card [title]="'Skill levels' | translate" hideDivisor="true" [actions]="getSkillLevelActions()">
  <ng-container *ngIf="!isLoading; else loading">
    <app-table #skillLevelsTable [columns]="getSkillLevelsTableColumns()" [rows]="getSkillLevelsTableData()" [paginator]="skillLevelsPaginator"></app-table>
  </ng-container>
</app-scotty-card>


<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
